import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/LoginView.vue'),
      meta: { public: true },
    },
    {
      path: '/access-denied',
      name: 'AccessDenied',
      component: () => import('@/views/AccessDeniedView.vue'),
      meta: { public: true },
    },
    {
      path: '/',
      component: () => import('@/layouts/AppLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        { path: '', redirect: '/dashboard' },
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: () => import('@/views/DashboardView.vue'),
        },
        {
          path: 'team',
          name: 'Team',
          component: () => import('@/views/TeamView.vue'),
        },
        {
          path: 'team/:pseudoId',
          name: 'TeamMember',
          component: () => import('@/views/TeamMemberView.vue'),
        },
        {
          path: 'sign-offs',
          name: 'PendingSignoffs',
          component: () => import('@/views/PendingSignoffsView.vue'),
        },
        {
          path: 'sign-offs/:formId',
          name: 'FormDetail',
          component: () => import('@/views/FormDetailView.vue'),
        },
        {
          path: 'opportunities',
          name: 'Opportunities',
          component: () => import('@/views/OpportunitiesView.vue'),
        },
        {
          path: 'skills-validation',
          name: 'SkillsValidation',
          component: () => import('@/views/SkillsValidationView.vue'),
        },
        {
          path: 'dev-plans',
          name: 'DevPlans',
          component: () => import('@/views/DevPlansView.vue'),
        },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach(async (to) => {
  if (to.meta.public) return true

  const auth = useAuthStore()

  if (!auth.isAuthenticated) {
    await auth.initSession()
    if (!auth.isAuthenticated) {
      await auth.redirectToLogin()
      return false
    }
  }

  // Role check — must have manager role
  if (!auth.hasManagerRole) {
    return { name: 'AccessDenied' }
  }

  return true
})
